import React from 'react';

import './App.css';
import DeckGL, { IconLayer } from 'deck.gl';
import { StaticMap } from 'react-map-gl';
import * as d3 from 'd3';
import Airplane from './airplane-icon.jpg';
import destinationPoint from './destinationPoint';

// Set your mapbox access token here
const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiamJvbGxpbmciLCJhIjoiY2p4ODUwYzY1MGhsNzN1dGgxMWRuM2pvdiJ9.zEEQFX-43Di8soIc_Dh_FA';

// Initial viewport settings
const initialViewState = {
  // longitude: -122.41669,
  // latitude: 37.7853,
  longitude: -118.134651,
  latitude: 33.803223,
  zoom: 13,
  pitch: 0,
  bearing: 0
};

// Data to be used by the LineLayer
// const data = [
//   {
//     // Latitude: 33.803223 | Longitude: -118.134651
//     // sourcePosition: [-122.41669, 37.7853],
//     // targetPosition: [-122.41669, 37.781]
//     sourcePosition: [-118.134651, 33.803223],
//     targetPosition: [-118.134651, 33.808223]
//   }
// ];

class App extends React.Component {
  state = {
    airplanes: []
  };

  currentFrame = null;
  timer = null;
  fetchEverySeconds = 10;
  framesPerFetch = this.fetchEverySeconds * 60;

  componentDidMount() {
    this.fetchData();
  }
  fetchData = () => {
    d3.json('https://opensky-network.org/api/states/all').then(({ states }) =>
      this.setState(
        {
          airplanes: states.map(d => ({
            icao24: d[0],
            callsign: d[1],
            origin_country: d[2],
            time_position: d[3],
            last_contact: d[4],
            longitude: d[5],
            latitude: d[6],
            baro_altitude: d[7],
            on_ground: d[8],
            velocity: d[9],
            true_track: -d[10],
            vertical_rate: d[11],
            sensors: d[12],
            geo_altitude: d[13],
            squawk: d[14],
            spi: d[15],
            position_source: d[16],
            interpolatePos: d3.geoInterpolate(
              [d[5], d[6]],
              destinationPoint(d[5], d[6], d[9] * 60, d[10])
            )
          }))
        },
        () => {
          this.startAnimation();
          setTimeout(this.fetchData, 10 * 1000);
        }
      )
    );
  };

  startAnimation = () => {
    if (this.timer) {
      this.timer.stop();
    }
    this.currentFrame = 0;
    this.timer = d3.timer(this.animationFrame);
  };

  animationFrame = () => {
    let { airplanes } = this.state;
    airplanes = airplanes.map(d => {
      const [longitude, latitude] = d.interpolatePos(
        this.currentFrame / this.framesPerFetch
      );
      return {
        ...d,
        longitude,
        latitude
      };
    });
    this.currentFrame += 1;
    this.setState({ airplanes });
  };

  render() {
    // const layers = [];
    console.log(this.state.airplanes[0]);
    const layers = [
      new IconLayer({
        id: 'airplanes',
        data: this.state.airplanes,
        pickable: false,
        iconAtlas: Airplane,
        iconMapping: {
          airplane: {
            x: 0,
            y: 0,
            width: 512,
            height: 512
          }
        },
        sizeScale: 15,
        getPosition: d => [d.longitude, d.latitude],
        getIcon: d => 'airplane',
        // getAngle: d => 45 + (d.true_track * 180 ) / Math.PI,
        getAngle: d => 45 + d.true_track,
        getSize: d => 5
      })
    ];

    // const layers = [new LineLayer({ id: 'line-layer', data })];

    return (
      <DeckGL
        initialViewState={initialViewState}
        controller={true}
        layers={layers}
      >
        <StaticMap mapboxApiAccessToken={MAPBOX_ACCESS_TOKEN} />
      </DeckGL>
    );
  }
}

export default App;
